import React from 'react';
import { Card, Form, Row, Col, Button, Alert } from 'react-bootstrap';
import { FaPlay, FaInfoCircle } from 'react-icons/fa';
import Spinner from '../Spinner';
import FormFieldRenderer from './FormFieldRenderer';
import { getNestedValue } from './utils/formUtils';

const InputParametersForm = ({ 
  formFields, 
  formData, 
  formErrors,
  executing,
  executingEnvironment,
  error,
  onInputChange,
  onSubmit
}) => {
  // Helper function to check if field should be full width
  const isFullWidthField = (fieldName) => {
    const lowerFieldName = fieldName.toLowerCase().replace(/[_\s]/g, '');
    // Check for Context and main_task fields specifically
    return lowerFieldName === 'context' || 
           lowerFieldName === 'maintask' || 
           lowerFieldName === 'main_task';
  };

  return (
    <Card className="test-card mb-4">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="section-heading" style={{ paddingLeft: '12px' }}>Input Parameters</h2>
        </div>
      </Card.Header>
      
      <Card.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            <FaInfoCircle className="me-2" />
            {error}
          </Alert>
        )}
        
        <Form>
          <Row className="mb-3">
            {formFields.map(field => {
              if (field.isGroup) {
                return (
                  <Col md={12} key={field.name} className="mb-3">
                    <h5 className="form-section-title">
                      {field.label}
                    </h5>
                    {field.description && (
                      <p className="text-muted small mb-3" style={{ paddingLeft: '12px' }}>{field.description}</p>
                    )}
                  </Col>
                );
              }
              
              // Check if this field should be full width
              const shouldBeFullWidth = isFullWidthField(field.name);
              
              const isLarge = field.name.toLowerCase().includes('instructions') ||
                            field.name.toLowerCase().includes('architecture') ||
                            field.format === 'textarea' ||
                            field.type === 'array';
              
              // Use full width (12 columns) for Context and main_task, otherwise use existing logic
              const columnSize = shouldBeFullWidth ? 12 : (isLarge ? 12 : 4);
              
              return (
                <Col md={columnSize} key={field.name} className="mb-3">
                  <Form.Group style={{ width: '100%' }}>
                    <Form.Label className={field.required ? 'required-field' : ''} style={{ paddingLeft: '12px' }}>
                      {field.label}
                    </Form.Label>
                    
                    <FormFieldRenderer
                      field={field}
                      value={getNestedValue(formData, field.name) || (field.type === 'array' ? [] : '')}
                      onChange={onInputChange}
                      isInvalid={!!formErrors[field.name]}
                      isFullWidth={shouldBeFullWidth}
                    />
                    
                    {field.description && (
                      <Form.Text className="field-description" style={{ paddingLeft: '12px' }}>
                        <FaInfoCircle className="me-1" />
                        {field.description}
                      </Form.Text>
                    )}
                    
                    {formErrors[field.name] && (
                      <div className="field-error" style={{ paddingLeft: '12px' }}>{formErrors[field.name]}</div>
                    )}
                  </Form.Group>
                </Col>
              );
            })}
          </Row>
          
          <div className="execute-buttons">
            <Button
              variant="primary"
              onClick={() => onSubmit('development')}
              disabled={executing}
              className="execute-btn"
            >
              {executing && executingEnvironment === 'development' ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Running in Dev...
                </>
              ) : (
                <>
                  <FaPlay className="me-2" />
                  Execute in Development
                </>
              )}
            </Button>
            
            <Button
              variant="danger"
              onClick={() => onSubmit('production')}
              disabled={executing}
              className="execute-btn"
            >
              {executing && executingEnvironment === 'production' ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Running in Prod...
                </>
              ) : (
                <>
                  <FaPlay className="me-2" />
                  Execute in Production
                </>
              )}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default InputParametersForm;